<template>
    <section>
        <sui-segment basic>
            <h2 is="sui-header" floated="right" color="grey">
                <sui-icon name="file alternate"/>
                <sui-header-content>Quejas REDECO</sui-header-content>
            </h2>
            <br>
        </sui-segment>
        <sui-segment basic>
            <sui-form v-on:submit.prevent>
                <sui-form-fields fields="three">
                    <sui-form-field>
                        <label>Folio</label>
                        <sui-input
                            v-model="searchRecord.folio"
                            placeholder="Folio"
                        />
                    </sui-form-field>
                    <sui-form-field>
                        <label>Causa</label>
                        <sui-dropdown
                            placeholder="Seleccione"
                            selection
                            search
                            v-model="searchRecord.reasonId"
                            :options="reasonOptions"
                        />
                    </sui-form-field>
                    <sui-form-field>
                        <label>Estatus de la queja</label>
                        <sui-dropdown
                            placeholder="Seleccione"
                            selection
                            search
                            v-model="searchRecord.statusId"
                            :options="statusOptions"
                        />
                    </sui-form-field>
                    <sui-form-field>
                        <label>Queja inhabilitada</label>
                        <sui-checkbox v-model="searchRecord.inactive"/>
                    </sui-form-field>
                </sui-form-fields>
                <sui-form-fields fields="two">
                    <sui-form-field>
                        <label>Rango de fechas</label>
                        <v-date-picker v-model="range" is-range locale="es" @input="formatDates">
                            <template v-slot="{ inputValue, inputEvents, isDragging }">
                                <sui-form-fields fields="two">
                                    <sui-form-field>
                                        <label>Fecha inicial</label>
                                        <input
                                            class="flex-grow pl-8 pr-2 py-1 bg-gray-100 border rounded w-full"
                                            :class="isDragging ? 'text-gray-600' : 'text-gray-900'"
                                            :value="inputValue && inputValue.start ? inputValue.start : null"
                                            v-on="inputEvents.start"
                                          />
                                    </sui-form-field>
                                    <sui-form-field>
                                        <label>Fecha final</label>
                                        <input
                                            class="flex-grow pl-8 pr-2 py-1 bg-gray-100 border rounded w-full"
                                            :class="isDragging ? 'text-gray-600' : 'text-gray-900'"
                                            :value="inputValue && inputValue.end ? inputValue.end : null"
                                            v-on="inputEvents.end"
                                          />
                                    </sui-form-field>
                                </sui-form-fields>
                            </template>
                        </v-date-picker>
                    </sui-form-field>
                </sui-form-fields>
                <sui-button primary icon="search" @click="saveFilters(); loadRecords()">Buscar</sui-button>
                <sui-button secondary icon="cancel" @click="restoreRecords(); saveFilters()">Limpiar</sui-button>
                <sui-button positive floated="right" icon="plus" @click="addRecord()">Agregar</sui-button>
            </sui-form>
        </sui-segment>
        <GenericPaginatedList
            :color="'blue'"
            :recordName="recordName"
            :headers="headers"
            :callback="loadRecords"
            :navigate="{ value: true, blank: true }">
        </GenericPaginatedList>
    </section>
</template>

<script>
import ComplaintService from '@/services/ComplaintService'
import Utils from '@/common/Utils.js'
import Mixins from '@/mixins/index.js'
import GenericPaginatedList from '@/components/Generic/PaginatedList.vue'

export default {
    name: 'RedecoComplaintList',
    components: { GenericPaginatedList },
    mixins: [ Mixins ],
    data () {
        return {
            apiEndpoint: '/complaints/redeco',
            recordName: 'RedecoComplaint',
            total: 0,
            record: {},
            records: [],
            searchRecord: {
                page: 1,
                pageSize: 35,
                order: 'DESC',
                statusId: []
            },
            status: [],
            products: [],
            reasons: [],
            headers: [
                { name: 'Fecha', value: 'dateComplaint', type: 'dateShort', cellclass: 'txtc', class: 'txtc', width: 1 },
                { name: 'Folio', value: 'folio', width: 2 },
                { name: 'Producto', value: 'productId', type: 'function', callback: 'setProductStr', width: 2 },
                { name: 'Causa', value: 'reasonId', type: 'function', callback: 'setReasonStr', width: 10 },
                { name: 'Estatus', value: 'statusId', type: 'function', callback: 'setStatusStr', cellclass: 'txtc', class: 'txtc', width: 1 },
                { name: 'Reportada', value: 'reported', type: 'function', callback: 'setReportedStr', cellclass: 'txtc', class: 'txtc', width: 1 }
            ]
        }
    },
    beforeMount () {
        if (!this.$store.getters.isLoggedIn) {
            window.location.replace('/login')
        }
    },
    async mounted () {
        const loader = this.$loading.show()
        try {
            await this.loadProducts()
            await this.loadReasons()
            await this.loadStatus()
            await this.loadRecords(1, '/complaints/redeco', 'records', 'total', this.searchRecord)
        } catch (error) {
            this.$swal('Error', error.message, 'error')
        }
        loader.hide()
    },
    computed: {
        statusOptions () {
            return Utils.displayOptionsFromArray(this.status, 'status_id', 'status_description')
        },
        productOptions () {
            return Utils.displayOptionsFromArray(this.products, 'productId', 'product')
        },
        reasonOptions () {
            return Utils.displayOptionsFromArray(this.reasons, 'causaId', 'causa')
        }
    },
    methods: {
        saveFilters () {
            const data = Object.assign({ range: this.range }, this.searchRecord)
            this.$store.dispatch('setFilters', { recordName: this.recordName, data })
        },
        formatDates () {
            if (!this.range) {
                delete this.searchRecord.fechaInicio
                delete this.searchRecord.fechaFin
            } else {
                if (this.range.start !== null) {
                    this.Vue.set(this.searchRecord, 'fechaInicio', this.moment.utc(this.range.start).format('YYYY-MM-DD'))
                }
                if (this.range.end !== null) {
                    this.Vue.set(this.searchRecord, 'fechaFin', this.moment.utc(this.range.end).format('YYYY-MM-DD'))
                }
            }
        },
        async loadStatus () {
            try {
                this.status = await ComplaintService.getRedecoStatus()
            } catch (error) {
                throw new Error('Ocurrio un error al cargar los estatus de las quejas REDECO')
            }
        },
        async loadProducts () {
            try {
                const { products } = await ComplaintService.getRedecoProducts()
                this.products = products
            } catch (error) {
                throw new Error('Ocurrio un error al cargar los productos de las quejas REDECO')
            }
        },
        async loadReasons () {
            try {
                const { causas } = await ComplaintService.getRedecoReasons('026911951282')
                this.reasons = causas
            } catch (error) {
                throw new Error('Ocurrio un error al cargar las causas de las quejas REDECO')
            }
        },
        setStatusStr (obj) {
            return Utils.displayOptionFromList(this.statusOptions, obj.statusId)
        },
        setProductStr (obj) {
            return Utils.displayOptionFromList(this.productOptions, obj.productId)
        },
        setReasonStr (obj) {
            return Utils.displayOptionFromList(this.reasonOptions, obj.reasonId)
        },
        setReportedStr (obj) {
            return obj.reported ? 'Si' : 'No'
        }
    }
}
</script>
